import { cn } from "@/shared/libs/commonUtils";
export default function Skeleton({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div data-slot="skeleton" className={cn("bg-muted dark:bg-muted/10 animate-pulse rounded-md", className)} {...props} data-sentry-component="Skeleton" data-sentry-source-file="Skeleton.tsx" />;
}